module.exports = __webpack_public_path__ + "img/jcyj_index7.ce99d68c.jpg";